<template>
  <v-container>
    <v-row>
      <v-col cols="3">
        <v-select
          v-model="editedItem.addDeduct"
          :items="addDeductCodeTypes"
          id="bankReconTransItemAddDeductCodeSelect"
          class="bank-recon-trans-item-add-deduct-code-select"
          label="Add Deduct Code"
          item-text="description"
          item-value="name"
        ></v-select>
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="editedItem.description"
          v-uppercase=globalSettingItem.conEverythingToCaps
          label= "Description"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'bankCodesEditedItem',
  mixins: [GlobalToCaps],
  components: {
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'bankCodes-Dialog',
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
    ]),
    ...mapState({
      addDeductBankReconTypes: (state) => state.enums.SaiBankReconAddDeductEnum,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    addDeductCodeTypes() {
      if (!this.addDeductBankReconTypes) {
        return [];
      }
      return this.addDeductBankReconTypes;
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
  },
};
</script>
